import axios from "axios";

import {grabHeroNew} from "../grabHeroNew.js";
import {buildCharacterQuery} from "../buildCharacterQuery.js";

export function getMainCharacterData(searchedCharacter,changeCharacter,showComicArea,currentCharacterInfo){
    
    /////// 1. get the Main characters data from the API using the searchedCharacter in Redux
    /////// 2. then use grabHeroNew() to clean up the returned data to only use what we need
    /////// 3. then store the end results into Redux with changeCharacter()

    //this is a reducer function that manages the comicsAreaReadyToShow property. 
    //since everything starts with this function getMainCharacterData(), its set to false here
    //then when the comics area has all the data it needs, this will be set to true in getComicListData() 
    //THEN the components on the character page know to render
    showComicArea(false);

    var characterQuery = buildCharacterQuery(searchedCharacter);
    var characterData;

    axios.get(characterQuery)
    .then(function (response1) {
        characterData = grabHeroNew(response1,currentCharacterInfo);
        changeCharacter(characterData);
        //console.log("IM THE MAIN CHARACTER DATA")
        //console.log(characterData)
    })

}


// WEBPACK FOOTER //
// ./src/components/includes/axios/getMainCharacterData.js